import { render, staticRenderFns } from "./managedInstructionAssignmentTable.vue?vue&type=template&id=5a692cca"
import script from "./managedInstructionAssignmentTable.vue?vue&type=script&lang=js"
export * from "./managedInstructionAssignmentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports